/* Replace assets/announcement.js with this entire file, then reload the preview. */
(function () {
  'use strict';

  const controllerKey = '__mottoAnnouncementControllerV1';
  const sectionSelector = '.section-announcement';
  const sliderSelector = '.announcement-bar--swiper';
  const cleanups = new WeakMap();

  // Shopify can execute a section's asset again after an editor update.
  if (window[controllerKey]) {
    window[controllerKey].initAll();
    return;
  }

  const readNumber = (value, fallback, minimum) => {
    if (value == null || value === '') return fallback;
    const number = Number(value);
    return Number.isFinite(number) && number >= minimum ? number : fallback;
  };

  function initSection(section) {
    if (!section || !section.matches(sectionSelector)) return;
    const slider = section.querySelector(sliderSelector);
    if (!slider || (slider.swiper && !slider.swiper.destroyed)) return;
    if (typeof window.Swiper !== 'function') return;
    cleanups.get(slider)?.();

    const slideCount = slider.querySelectorAll(
      '.swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)'
    ).length;
    if (!slideCount) return;

    const rowsMobile = Math.floor(readNumber(slider.dataset.rowsMobile, 1, 1));
    const rowsDesktop = Math.floor(readNumber(slider.dataset.rows, 1, 1));
    const desktop = window.matchMedia('(min-width: 765px)');
    let swiper;

    function build() {
      const previousIndex = swiper && !swiper.destroyed ? swiper.realIndex : 0;
      if (swiper && !swiper.destroyed) swiper.destroy(true, true);
      const rows = desktop.matches ? rowsDesktop : rowsMobile;
      const canScroll = slideCount > rows;

      swiper = new window.Swiper(slider, {
        direction: 'vertical',
        spaceBetween: 0,
        slidesPerView: rows,
        initialSlide: canScroll ? Math.min(previousIndex, slideCount - 1) : 0,
        speed: readNumber(slider.dataset.speed, 800, 0),

        // The theme already fixes the bar height with --announcement-height.
        // Keep originals and loop duplicates on the same vertical geometry.
        autoHeight: false,
        loop: canScroll,
        watchOverflow: true,

        autoplay: {
          enabled: canScroll,
          delay: readNumber(slider.dataset.delay, 2000, 1),
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          waitForTransition: true,
        },
      });
    }

    // In Swiper 8, breakpoint overrides do not fully toggle autoplay's
    // hover handlers. Rebuild only when the number of displayed rows changes.
    if (rowsMobile !== rowsDesktop) desktop.addEventListener('change', build);
    cleanups.set(slider, () => {
      desktop.removeEventListener('change', build);
      if (swiper && !swiper.destroyed) swiper.destroy(true, true);
      cleanups.delete(slider);
    });
    build();
  }

  function initAll() {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  }

  function unloadSection(event) {
    if (!event.target.matches(sectionSelector)) return;
    const slider = event.target.querySelector(sliderSelector);
    if (!slider) return;
    const cleanup = cleanups.get(slider);
    if (cleanup) cleanup();
    else if (slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.destroy(true, true);
    }
  }

  window[controllerKey] = { initAll };
  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
  document.addEventListener('shopify:section:unload', unloadSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
